import React from 'react';
import ReactLoading from "react-loading";
import './Style/LoacdingScreen.css'

const LoadingScreen = () => {
    return (
        <div className="LoadingBack">
            <div className="loadingItem">
                <ReactLoading type={"bars"} color={"white"}  z />
            </div>

        </div>
    );
};

export default LoadingScreen;